module.exports = __webpack_public_path__ + "download/img/uniondrug_phone.4342de38.png";